import React, {
  Fragment,
} from 'react';
import { routerRedux } from 'dva/router'
import { connect } from 'dva';
import PropTypes from 'prop-types';
import { Form, Input, Button, Checkbox, Modal, Radio, message} from 'antd';
// import { controllerFile } from 'controller';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import style from './styles.module.less';
import { storage } from 'utils';

let source = '';

class Login extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      name: '应用管理',
      visibleModel:false,
      roleValue:'',
    };
    this.getCaptcha = this.getCaptcha.bind(this);
    this.getCaptcha();
  }

  // 刷新验证码
  getCaptcha() {
    source = `web_${new Date().getTime()}`;
    this.props.dispatch({
      type: 'login/captchaFn',
      payload: {
        source: source
      }
    });
  }

  setLoading(flag) {
    this.props.dispatch({
      type: 'login/setLoading',
      payload: {
        loading: flag
      }
    });
  }
  handleOk(){
    if(this.state.roleValue){
      this.props.dispatch(routerRedux.push('/home'));
      const { userRoleData } = this.props;
      let obj = {};
      userRoleData.forEach(item=>{
        if(this.state.roleValue == item.roleId){
          obj = item
        }
      })
      storage.set('loginSelectRole', obj);
    }else{
      message.warning('请先选择当前角色')
    }
  }
  handleCancel(){
    this.setState({visibleModel:false})
  }
  onRadioChange(val){
    this.setState({roleValue:val.target.value})
  }
  onSearchRoleValue(val){
    this.props.dispatch({
      type: 'login/searchRole',
      payload: {
        searchValue: val,
      },
    })
  }

  inputInfo(){
    this.setLoading(false);
  }
  render() {
    const { visibleModel,roleValue} = this.state;
    const { captcha, message, homeConfig,changeUserRole,loading} = this.props;
    const onFinish = values => {
      this.setLoading(true);
      this.props.dispatch({
        type: 'login/loginFn',
        payload: {
          captcha: values.captcha,
          loginName: values.loginName,
          password: values.password,
          rememberMe: values.rememberMe,
          source: source,
        },
      }).then(t => {
        // 选择默认角色
        // this.setLoading(false);
        // this.setState({visibleModel:true});
      });
    };
    let mainLogoId = (homeConfig && homeConfig.code === 0 && homeConfig.mainLogoId.confValue);
    let logoStyle = !!mainLogoId ? {
      'backgroundImage': `url('${mainLogoId}')`
    } : null;
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    return <Fragment>
      <div className={style["wrapper"]}>
        {/* <div>
          <div className="logo ml80" style={logoStyle}></div>
        </div> */}
        <div className="mg-at login-wrapper">
          <Form
            name="normal_login"
            className="login-form"
            initialValues={{ remember: true }}
            onFinish={onFinish}

          >
            <div className="logo mg-at mb40" style={logoStyle}></div>
            {/*<div className="logo logo2"></div>*/}
            <Form.Item
              name="loginName"
              rules={[{ required: true, message: '请输入用户名!' }]}
            >
              <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="用户名" onChange={this.inputInfo.bind(this)}/>
            </Form.Item>
            <Form.Item
              name="password"
              rules={[{ required: true, message: '请输入密码!' }]}
            >
              <Input
                prefix={<LockOutlined className="site-form-item-icon" />}
                type="password"
                placeholder="密码"
                onChange={this.inputInfo.bind(this)}
              />
            </Form.Item>

            <div className="relative">
              <Form.Item
                name="captcha"
                rules={[{ required: true, message: '请输入验证码!' }]}
              >
                <Input
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="验证码" />
              </Form.Item>
              <div className="captcha" onClick={this.getCaptcha}>
                <img className="wr100 hr100" src={captcha} />
                <a className="pd10 fs12 cl333">看不清楚, 换一张</a>
              </div>
            </div>

            <Form.Item>
              <Form.Item name="rememberMe" valuePropName="checked" noStyle>
                <Checkbox>记住密码</Checkbox>
              </Form.Item>

              {/* <a className="login-form-forgot fr" href="">
                忘记密码
              </a> */}
            </Form.Item>

            <Form.Item style={{marginBottom: '50px'}}>
              <Button type="danger" htmlType="submit" className="login-form-button wr100" loading={loading}>
                登   录
              </Button>
              {
                message && (
                  <p className={style["forgetMe"]}>{message}</p>
                )
              }
            </Form.Item>

          </Form>
        </div>
        <Modal
          title="选择当前角色"
          visible={visibleModel}
          onOk={this.handleOk.bind(this)}
          onCancel={this.handleCancel.bind(this)}
          width={500}
        >
          <div style={{marginBottom:'20px'}}>
            <Input.Search
              placeholder="请输入搜索角色关键字"
              style={{ width: 300 }}
              onSearch={this.onSearchRoleValue.bind(this)}
            />
          </div>
          <div className={style["loginRadio"]}>
            <Radio.Group onChange={this.onRadioChange.bind(this)} value = {roleValue}>
              {changeUserRole.length >0 && changeUserRole.map(item=>{return <Radio style={radioStyle} value={item.roleId} key={item.roleId}>{item.roleName}</Radio>})}
            </Radio.Group>
          </div>
        </Modal>
      </div>
    </Fragment>;
  }
}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
  captcha: PropTypes.string.isRequired,
  loginInfo: PropTypes.object,
};

export default connect(({ common, login }) => {
  return { ...common, ...login }
})(Login);
